"use strict";
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["backspace"] = 8] = "backspace";
    KeyCodes[KeyCodes["escape"] = 27] = "escape";
    KeyCodes[KeyCodes["delete"] = 46] = "delete";
    KeyCodes[KeyCodes["backSlash"] = 191] = "backSlash";
})(KeyCodes = exports.KeyCodes || (exports.KeyCodes = {}));



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/key-codes.enum.js